<template>
  <!-- 评分星星 -->
  <div class="Rate">
    <div class="question">
      <div class="title bold">{{data.questionTitle}}</div>
      <!-- <div class="remarks fl">（最多选3个）</div> -->
    </div>
    
    <div class="answer">
      <div class="item" v-for="i in data.itemList" :key="i.questionTitle">

        <div class="item_text" v-for="o in JSON.parse(i.itemDes)" :key="JSON.stringify(o)">
          <span class="span">{{i.itemNo + '. ' + o.txt}}</span>
        </div>

        <div class="item_rate">
          <el-rate v-model="i.val" @change="change"></el-rate>
        </div>
      </div>
      <div class="answerObj none">{{answerObj}}</div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  computed: {
    answerObj () {
      let arr = this.data.itemList || []
      let brr = []
      let obj
      for (let i in arr) {
        if (arr[i].val * 1 !== 0) {
          let str = arr[i].itemId + ':' + arr[i].val
          brr.push(str)
        }
      }
      if (brr.length === 0) {
        obj = {
          msg: '请选择答案后提交'
        }
      } else {
        obj = {
          questionId: this.data.questionId,
          item: brr.join('|')
        }
      }
      return obj
    }
  },
  name: 'Rate',
  data () {
    return {
    }
  },
  methods: {
    change () {
      this.pushAnswer()
    },
    // 提交答案
    pushAnswer () {
      let data = {
        taskRelationId: this.$route.query.taskRelationId,
        answerDtoList: [this.answerObj]
      }
      this.$api.post('SAVE_CURRICULA_ANSWER', data, (res) => {
      })
    },
    // 初始化
    init () {
      if (this.data.answered) {
        let arr = this.data.answered.split('|')
        for (let i in this.data.itemList) {
          for (let o in arr) {
            if (this.data.itemList[i].itemId === arr[o].split(':')[0]) {
              this.$set(this.data.itemList[i], 'val', arr[o].split(':')[1] * 1)
              // this.data.itemList[i].val = arr[o].split(':')[1] * 1
            }
          }
        }
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.Rate{
  .question{
    margin-top: 24px;
    .title{
      line-height: 22px;
      font-size: 16px;
      color: #303133;
    }
    .remarks{
      color: #909399;
      font-size: 14px;
      line-height: 22px;
    }
  }
  .answer{
    .item{
      box-sizing: border-box;
      border-bottom: 1px solid #EBEEF5;
      .item_text{
        margin-top: 24px;
        color: #303133;
        margin-bottom: 8px;
        line-height: 22px;
      }
      .item_rate{
        margin-bottom: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/public/rate.vue